import { useQuery } from '@tanstack/react-query';

import { DatasetLabelColumnMapping } from '../../models/dataset.model';

import API from '../../services/api';

import queryKeys from './__queryKeys';

const getDatasetLabelColumns = async (datasetId?: number) => {
    if (!datasetId) return null;
    const { data } = await API.fetchDatasetLabelColumns(datasetId);
    return (data ?? {}) as DatasetLabelColumnMapping;
};

export default function useDatasetLabelColumnsQuery(datasetId?: number) {
    return useQuery({
        queryKey: queryKeys.datasetLabelColumns(datasetId),
        queryFn: () => getDatasetLabelColumns(datasetId),
        enabled: !!datasetId,
        staleTime: 60 * 60 * 1000,
    });
}
